var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dropdown",
    {
      attrs: { placement: "bottom", size: "default" },
      on: { command: _vm.onChangeLocale }
    },
    [
      _c(
        "d2-button",
        { staticClass: "d2-mr btn-text can-hover", attrs: { type: "text" } },
        [
          _c("d2-icon", {
            staticStyle: { "font-size": "16px" },
            attrs: { name: "globe" }
          })
        ],
        1
      ),
      _c(
        "el-dropdown-menu",
        {
          staticStyle: { border: "0px solid red", width: "250px" },
          attrs: { slot: "dropdown" },
          slot: "dropdown"
        },
        _vm._l(_vm.list, function(language) {
          return _c(
            "el-dropdown-item",
            {
              key: language.name,
              staticStyle: { display: "inline-block" },
              attrs: { command: language.name }
            },
            [
              _c("d2-icon", {
                staticClass: "d2-mr-5",
                attrs: {
                  name:
                    _vm.activeName == language.name
                      ? "dot-circle-o"
                      : "circle-o"
                }
              }),
              _vm._v(" " + _vm._s(_vm.$t(language.label)) + " ")
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }